/**
 * Almacenamiento de los borradores automáticos (ver `useDraft` en `drafts.ts`). Separado del hook
 * para que el cierre de sesión pueda borrarlos sin depender de React.
 */
export const PREFIX = 'eatherix.draft:';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

interface Stored<T> {
  value: T;
  savedAt: number;
}

export function read<T>(key: string): T | undefined {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return undefined;
    const stored = JSON.parse(raw) as Stored<T>;
    if (!stored || typeof stored.savedAt !== 'number' || Date.now() - stored.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(key);
      return undefined;
    }
    return stored.value;
  } catch {
    return undefined;
  }
}

export function write<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify({ value, savedAt: Date.now() } satisfies Stored<T>));
  } catch {
    // Sin espacio o sin permiso: el borrador simplemente no se guarda.
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Nada que hacer.
  }
}

/** Borra todos los borradores de este navegador (al cerrar sesión). */
export function clearAllDrafts(): void {
  try {
    for (const key of Object.keys(localStorage)) if (key.startsWith(PREFIX)) remove(key);
  } catch {
    // Nada que hacer.
  }
}
